/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "azure-devops-ui/Spinner", "azure-devops-ui/Util", "react", "../../Resources", "../Common/KubeFilterBar", "../Common/KubeZeroData", "../Constants", "../FluxCommon/ActionsCreatorManager", "../FluxCommon/StoreManager", "../KubeFactory", "../Services/ServicesTable", "./ServicesActionsCreator", "./ServicesFilterBar", "./ServicesStore", "./ServicesPivot.scss"], function (require, exports, Spinner_1, Util_1, React, Resources, KubeFilterBar_1, KubeZeroData_1, Constants_1, ActionsCreatorManager_1, StoreManager_1, KubeFactory_1, ServicesTable_1, ServicesActionsCreator_1, ServicesFilterBar_1, ServicesStore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ServicesPivot = /** @class */ (function (_super) {
        __extends(ServicesPivot, _super);
        function ServicesPivot(props) {
            var _this = _super.call(this, props, {}) || this;
            _this._onServicesFetched = function () {
                var storeState = _this._store.getState();
                _this.setState({
                    serviceList: storeState.serviceList,
                    isLoading: storeState.isLoading
                });
            };
            _this._markTTI = function () {
                if (!_this._isTTIMarked) {
                    KubeFactory_1.getTelemetryService().scenarioEnd(Constants_1.Scenarios.Services);
                }
                _this._isTTIMarked = true;
            };
            _this._isTTIMarked = false;
            KubeFactory_1.getTelemetryService().scenarioStart(Constants_1.Scenarios.Services);
            _this._actionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ServicesActionsCreator_1.ServicesActionsCreator);
            _this._store = StoreManager_1.StoreManager.GetStore(ServicesStore_1.ServicesStore);
            var storeState = _this._store.getState();
            _this.state = {
                serviceList: storeState.serviceList,
                isLoading: storeState.isLoading
            };
            _this._actionCreator.getServices(KubeFactory_1.KubeFactory.getKubeService());
            _this._store.addListener(Constants_1.ServicesEvents.ServicesFetchedEvent, _this._onServicesFetched);
            return _this;
        }
        ServicesPivot.prototype.render = function () {
            if (this.state.isLoading) {
                return React.createElement(Spinner_1.Spinner, { className: "flex flex-grow loading-services", size: "large" /* large */, label: Resources.LoadingServicesSpinnerLabel });
            }
            return (React.createElement(React.Fragment, null,
                this._getFilterBar(),
                React.createElement("div", { className: Util_1.css("services-pivot-data", "k8s-pivot-data") }, this._getContent())));
        };
        ServicesPivot.prototype.componentWillUnmount = function () {
            this._store.removeListener(Constants_1.ServicesEvents.ServicesFetchedEvent, this._onServicesFetched);
        };
        ServicesPivot.prototype._getContent = function () {
            var serviceSize = this.state.serviceList && this.state.serviceList.items ? this.state.serviceList.items.length : 0;
            return (serviceSize === 0 ? this._getZeroData() :
                React.createElement(ServicesTable_1.ServicesTable, { serviceList: this.state.serviceList || {}, nameFilter: this._getNameFilterValue(), typeSelections: this._getTypeFilterValue(), markTTICallback: this._markTTI }));
        };
        ServicesPivot.prototype._getFilterBar = function () {
            return (React.createElement(ServicesFilterBar_1.ServicesFilterBar, { className: Util_1.css("services-pivot-filter", "k8s-pivot-filter"), serviceList: this.state.serviceList || {}, filter: this.props.filter, filterToggled: this.props.filterToggled }));
        };
        ServicesPivot.prototype._getNameFilterValue = function () {
            var filterState = this.props.filter.getState();
            var filterItem = filterState ? filterState[KubeFilterBar_1.NameKey] : null;
            return filterItem ? filterItem.value : undefined;
        };
        ServicesPivot.prototype._getTypeFilterValue = function () {
            var filterState = this.props.filter.getState();
            var filterItem = filterState ? filterState[KubeFilterBar_1.TypeKey] : null;
            var selections = filterItem ? filterItem.value : [];
            return selections;
        };
        ServicesPivot.prototype._getZeroData = function () {
            setTimeout(this._markTTI, 0);
            return KubeZeroData_1.KubeZeroData.getServicesZeroData();
        };
        return ServicesPivot;
    }(React.Component));
    exports.ServicesPivot = ServicesPivot;
});
